import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ForestCoverSkeleton = () => {
  return (
    <Card className="h-md-100">
      <Card.Body>
        <Row className="justify-content-between g-0">
          <Col xs={5} sm={6} xxl className="pe-2">
            <h5 className="mt-1">
              <Skeleton />
            </h5>

            <Skeleton count={2} />
          </Col>
          <Col xs="auto">
            <Skeleton circle width={120} height={120} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ForestCoverSkeleton;
